import { GlobalRoutePath } from "@router/constants";
import DashboardMenu from "./DashboardMenu";
import CustomMenu,{CUSTOM_MENU_TYPE} from "./CustomMenu";
export const navbarItems = [
  {
    label: "Dashboards",
    id: "DASHBOARD",
    type: "select",
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.LANDING.path],
    to: GlobalRoutePath.LANDING.path,
    privilege: GlobalRoutePath.LANDING.privilege,
    component:(props)=><DashboardMenu {...props}/>
  },
  {
    label: "Manage Practices",
    id: "manage_practice",
    type: "select",
    activeLinks: [GlobalRoutePath.PRACTICES.path, GlobalRoutePath.JOB_SCHEDULER_EXECUTED.path],
    privilege: GlobalRoutePath.PRACTICES.privilege,
    services: [
      {
        label: "Setup/ Configuration",
        privilege: GlobalRoutePath.PRACTICES.privilege,
        to: GlobalRoutePath.PRACTICES.path,
      },
      {
        label: "Jobs Tracking",
        privilege: GlobalRoutePath.JOB_SCHEDULER_EXECUTED.privilege,
        to: GlobalRoutePath.JOB_SCHEDULER_EXECUTED.path,
      }
    ]
  },
  {
    label: "Download Center",
    id: "download_center",
    type: "select",
    activeLinks: [GlobalRoutePath.DOWNLOAD_CENTER_VIEW_FILES.path, GlobalRoutePath.DOWNLOAD_CENTER_UPLOAD.path],
    services: [
      {
        label: "View Files",
        privilege: GlobalRoutePath.DOWNLOAD_CENTER_VIEW_FILES.privilege,
        to: GlobalRoutePath.DOWNLOAD_CENTER_VIEW_FILES.path,
      },
      {
        label: "Upload Files",
        privilege: GlobalRoutePath.DOWNLOAD_CENTER_UPLOAD.privilege,
        to: GlobalRoutePath.DOWNLOAD_CENTER_UPLOAD.path,
      }
    ]
  },
  {
    label: "Referral 360",
    type: "link",
    privilege: GlobalRoutePath.REFERRAL360.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.REFERRAL360.path],
    to: GlobalRoutePath.REFERRAL360.path,
    //icon: "/static/images/smart-scheduler.svg",
  },
  {
    label: "Patient 360",
    id: "patient360",
    type: "select",
    privilege: GlobalRoutePath.PATIENT360.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.PATIENT360.path],
    to: GlobalRoutePath.PATIENT360.path,
    component:(props)=><CustomMenu {...props}/>
  },
  {
    label: "Patient Trial",
    id: "patient_trial",
    type: "select",
    privilege: GlobalRoutePath.PATIENTTRIAL.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.PATIENTTRIAL.path],
    to: GlobalRoutePath.PATIENTTRIAL.path,
    component:(props)=><CustomMenu {...props} type={CUSTOM_MENU_TYPE.PATIENTTRIAL}/>
  },
  {
    label: "Schedule a Patient",
    type: "link",
    privilege: GlobalRoutePath.SMART_SCHEDULER_PATIENTS.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.SMART_SCHEDULER_PATIENTS.path],
    to: GlobalRoutePath.SMART_SCHEDULER_PATIENTS.path,
    //icon: "/static/images/smart-scheduler.svg",
  },
  {
    label: "Smart Scheduler",
    type: "link",
    privilege: GlobalRoutePath.SMART_SCHEDULER.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.SMART_SCHEDULER.path],
    to: GlobalRoutePath.SMART_SCHEDULER.path,
    //icon: "/static/images/smart-scheduler.svg",
  },
  {
    label: "eFax",
    id: "efax",
    type: "link",
    privilege: GlobalRoutePath.EFAX.privilege,
    openInNewTab: false,
    activeLinks: [GlobalRoutePath.EFAX.path],
    to: GlobalRoutePath.EFAX.path,
    //icon: "/static/images/smart-scheduler.svg",
  },
  {
    label: "AI Services",
    id: "AI_SERVICES",
    privilege: GlobalRoutePath.AI_SERVICES.privilege,
    type: "select",
    activeLinks: [GlobalRoutePath.AI_SERVICES.path],
    //icon: "/static/images/ai-services.svg",
    services: [
      {
        label: "Speech To Text",
        privilege: "TOOLS_VADAAMI",
        to: "/ai-services/speech-to-text",
      },
      {
        label: "Copilot",
        privilege: "TOOLS_COPILOT",
        to: "/ai-services/copilot",
      },
      //{ label: "eFax", privilege: "TOOLS_EFAX", to: "/ai-services/e-fax" },
    ],
  },
  /* {
    label: "Settings",
    id: "SETTINGS",
    type: "select",
    activeLinks: ["/settings"],
    icon: "/static/images/settings.svg",
    services: [
      {
        label: "Service Subscription",
        privilege: "SERVICE SUBSCRIPTION",
				icon:"/static/images/subscription.svg",
        to: "/settings",
      },
      {
        label: "Payers And Measures",
        privilege: "PAYER MEASURE",
				icon:"/static/images/clinic.svg",
        to: "/settings/payersandmeasures",
      },
      {
        label: "Clinic Management",
        privilege: "CLINIC MANAGEMENT",
				icon:"/static/images/clinic.svg",
        to: "/settings/clinicmanagement",
      },
      {
        label: "Customize App",
        privilege: "APP CUSTOMIZATION",
				icon:"/static/images/customize.svg",
        to: "/settings/customizeapp",
      },
      {
        label: "User Management",
        privilege: "USER MANAGEMENT",
				icon:"/static/images/users.svg",
        to: "/settings/usermanagement",
      },
      {
        label: "User Role Management",
        privilege: "ROLE MANAGEMENT",
				icon:"/static/images/user-roles.svg",
        to: "/settings/userrolemanagement",
      },
      { label: "Data Import", 
        privilege: "DATA", 
        to: "/settings/dataimport" ,
				icon:"/static/images/data-import.svg",
      },
      {
        label: "Scheduler",
        privilege: "SMART_SCHEDULER_ADMIN",
				icon:"/static/images/smart-scheduler.svg",
        to: "/settings/smartscheduler",
      },
      { label: "Help Center", to: "/settings/helpcenter",icon:"/static/images/help.svg" },
    ],
  }, */
];

export const firstActiveRoute = (permissionCtxt,activeLinks)=>{
      const links = navbarItems.map(lk=>(lk.type == 'link' || !lk.services)?lk:lk.services.map(ls=>({...ls,activeLinks:[ls.to]}))).flat();
      const activeLink = links.find(lk=>(!!lk.activeLinks && lk.activeLinks.some(l=>location.pathname.includes(l))));
      const availableLinks = links.filter(l=>!isHidden(l,permissionCtxt) && (!activeLinks || activeLinks.includes(l.id)));
      const hasAccess = !!availableLinks.find(al=>al.to == activeLink?.to)
      return {firstRoute:(availableLinks[0]?.to || GlobalRoutePath.USER_PROFILE.path),hasAccess,currentRoute:activeLink?.to,availableLinks}
}
export const hasPermission = (item,permissionCtxt) => !item.privilege || permissionCtxt.hasAccess(item.privilege)
export const isHidden = (navbarItem,permissionCtxt) => {
  if (navbarItem.isHidden) return navbarItem.isHidden({ permissionCtxt });
  if (!hasPermission(navbarItem, permissionCtxt)) return true;
  // Hide a parent menu when it only has child services and none of them are accessible.
  if (!navbarItem.component && Array.isArray(navbarItem.services) && navbarItem.services.length > 0) {
    return !navbarItem.services.some(service => hasPermission(service, permissionCtxt));
  }
  return false;
};

